import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useAccount } from '@azure/msal-react';
import { Button } from '@upmc/ims.component-library';

import classnames from 'classnames';
import Spinner from '../../../components/UI/Spinner/Spinner';
import * as actions from '../../../store/uar/actions';
import { Headline4 } from '../../../components/UI/MDC/Typography/Typography';
import Card from '../../../components/UI/MDC/Card/Card';
import StyleAuxiliary from '../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';

import classes from '../UserAccessReview.module.scss';
import ErrorPage from '../components/ErrorPage';

const UARLayout = props => {
	const adalProfile = useSelector(state => state.uar.adalProfile);
	const dispatch = useDispatch();
	const account = useAccount();
	useEffect(() => {
		if (!adalProfile) {
			if (account) {
				dispatch(
					actions.setAdalProfile({
						payload: account,
					})
				);
			}
		}
	});

	let title = <Headline4>{props.title}</Headline4>;
	let header = props.help ? (
		<StyleAuxiliary classes={classnames(classes['title__container'])}>
			<Button sx={{ visibility: 'hidden'}}>
				Help
			</Button>
			{title}
			<Button
				variant='text'
				aria-label='Help'
				color='primary'
				href={props.help}
				rel='noopener noreferrer'
				target='_blank'
				title='Help'
				
			>
				Help
			</Button>
		</StyleAuxiliary>
	) : (
		title
	);

	let body = props.children;
	if (props.error) {
		body = <ErrorPage message={props.errorMessage} />;
	} else if (props.loading) {
		body = <Spinner />;
	} else if (props.canPerformActions === false) {
		body = (
			<ErrorPage
				message={'You do not have permission to perform this action.'}
			/>
		);
	}

	return (
		<StyleAuxiliary
			classes={classnames(classes['root__container'], 'mdc-typography')}
		>
			<Card xlarge classes={classes['center']}>
				{header}
				{body}
			</Card>
		</StyleAuxiliary>
	);
};

export default UARLayout;
